import Start from '../components/Start.vue';
import Bahnnostalgie from '../components/Bahnnostalgie.vue';
import Bahntechnik from '../components/Bahntechnik.vue';
import Bahntziele from '../components/Bahnziele.vue';
import Modelleisenbahn from '../components/Modelleisenbahn.vue';
import Info from '../components/Info.vue';
import MovieDetail from '../components/MovieDetail.vue';
import Player from '../components/Player.vue';

export const routes = [
	{path: '', component: Start},
	{path: '/bahnnostalgie', component: Bahnnostalgie},
	{path: '/bahntechnik', component: Bahntechnik},
	{path: '/bahnziele', component: Bahntziele},
	{path: '/modelleisenbahn', component: Modelleisenbahn},
	{path: '/movie-detail/:movieID', component: MovieDetail, props: true},
	{path: '/player/:movieID', component: Player, props: true, name: 'player'},
	{path: '/info', component: Info},
];



// WEBPACK FOOTER //
// ./src/lib/routes.js